import React from 'react';
import { Link } from 'react-router-dom';
import heroImage from '../../../../assets/images/solutiondetails/hero/hero.jpg';
import './Hero.css';

const Hero = ({ category, title, description, cta, backgroundImage }) => {
  if (!title) {
    return null;
  }

  return (
    <section className="solution-details-hero">
      <div className="solution-details-hero__inner">
        <div className="solution-details-hero__copy">
          {category ? <p className="solution-details-hero__eyebrow">{category}</p> : null}
          <h1 className="solution-details-hero__title">{title}</h1>
          {description ? <p className="solution-details-hero__text">{description}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="solution-details-hero__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </div>
      </div>

      <div className="solution-details-hero__media">
        <img
          className="solution-details-hero__image"
          src={backgroundImage || heroImage}
          alt=""
          aria-hidden="true"
        />
      </div>
    </section>
  );
};

export default Hero;
